<template>
    <stay-fire-island-logo v-if="uiStore.tenant && uiStore.tenant.id == 2" />
    <stay-marquis-logo v-else />
</template>

<script type="text/javascript">
    import StayMarquisLogo from '@/assets/logos/staymarquis.svg.vue';
    import StayFireIslandLogo from '@/assets/logos/stayfireisland.svg.vue';

    import { UseUIStore } from '@/store/UI.js';

    export default {

        components: {
            StayMarquisLogo,
            StayFireIslandLogo,
        },

        setup() {
            return {
                uiStore: UseUIStore(),
            };
        },
        
    };

</script>